import { NgModule } from '@angular/core';
import {
    FcpFormFieldModule,
    FcpIconModuleSVG,
    FcpInputModule,
    FcpSelectModule,
    FcpCheckboxModule
} from 'fc-ui-components';

import { SharedModule } from 'shared/shared.module';
import { AlertModule } from 'components/alert/alert.module';

import { AddressFormComponent } from './address-form/address-form.component';
import { GlnFormComponent } from './gln-form/gln-form.component';

@NgModule({
    imports: [
        SharedModule,
        AlertModule,
        FcpFormFieldModule,
        FcpInputModule,
        FcpSelectModule,
        FcpIconModuleSVG,
        FcpCheckboxModule
    ],
    declarations: [AddressFormComponent, GlnFormComponent],
    exports: [AddressFormComponent, GlnFormComponent]
})
export class FormsModule {}
